module.exports = __webpack_public_path__ + "static/media/icon-3.f00c2dc2.png";